export default __webpack_public_path__ + "static/media/pay1-points-fixed-icon.e89a1ce3.svg";